import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { repeat as c } from '../../../../node_modules/lit-html/directives/repeat.js';
import css_248z from './form-phone-field.scss.js';

class FormPhoneField extends s {
    constructor() {
        super(...arguments);
        this.id = '';
        this.name = '';
        this.class = '';
        this.dataFDataInput = '';
        this.selectedCode = '';
        this.phoneNumber = '';
        this.countries = [
            { code: '+1', name: 'United States', flag: '🇺🇸' },
            { code: '+44', name: 'United Kingdom', flag: '🇬🇧' },
            { code: '+91', name: 'India', flag: '🇮🇳' },
            { code: '+81', name: 'Japan', flag: '🇯🇵' },
            { code: '+49', name: 'Germany', flag: '🇩🇪' },
        ];
        this.filterText = '';
        this.isOpen = false;
        this.errorMessage = '';
        this.required = false;
    }
    // Handles input changes to filter countries
    handleInput(event) {
        const target = event.target;
        const inputValue = target.value;
        // Allow only '+' at the start and numbers after
        if (/^\+?[0-9]*$/.test(inputValue)) {
            this.filterText = inputValue;
        }
        else {
            target.value = this.filterText;
        }
        this.isOpen = true;
        this.validate();
    }
    // Selects a country when an item in the dropdown is clicked
    selectCountry(country) {
        console.log('Country selected:', country);
        this.selectedCode = country.code;
        this.filterText = country.code; // Update only the country code in the input
        this.isOpen = false; // Close the dropdown after selection
        this.validate();
        this.requestUpdate(); // Update the component
    }
    // Filters the countries based on the input text
    get filteredCountries() {
        return this.countries.filter(country => `${country.code} ${country.name}`
            .toLowerCase()
            .includes(this.filterText.toLowerCase()));
    }
    // Handle input focus to open the dropdown
    handleFocus() {
        this.isOpen = true;
    }
    // Handle input blur to close the dropdown
    handleBlur() {
        this.isOpen = false;
    }
    // Handles changes in the phone number input
    handlePhoneNumberChange(event) {
        const target = event.target;
        const phoneValue = target.value.replace(/\D/g, '');
        this.phoneNumber = phoneValue;
        this.validate();
    }
    // Renders error messages if there are any validation issues
    renderError() {
        return this.errorMessage
            ? x `<span class="Form__Element__ValidationError" role="alert">${this.errorMessage}</span>`
            : '';
    }
    // Input validation logic
    validate() {
        // Skip validation if 'required' is false
        if (!this.required) {
            this.errorMessage = '';
            return;
        }
        // Perform validation only if 'required' is true
        this.errorMessage = '';
        if (!this.selectedCode && !this.phoneNumber) {
            this.errorMessage = 'Country code and phone number are missing';
        }
        else if (!this.selectedCode) {
            this.errorMessage = 'Country code is missing';
        }
        else if (!this.countries.find(c => c.code === this.selectedCode)) {
            this.errorMessage = 'Invalid country code';
        }
        else if (!this.phoneNumber) {
            this.errorMessage = 'Phone number is missing';
        }
        this.requestUpdate();
    }
    toggleDropdown() {
        this.isOpen = !this.isOpen;
    }
    // Handle the keyup event for selecting a country with "Enter"
    handleKeyUp(event, country) {
        if (event.key === 'Enter') {
            this.selectCountry(country);
        }
    }
    // Renders the dropdown with filtered countries
    renderDropdown() {
        return x `<div class="${this.isOpen ? 'show' : 'hide'}"><div class="dropdown-list ${this.isOpen ? 'show' : ''}">${c(this.filteredCountries.slice(0, 5), country => country.code, country => this.renderDropdownItem(country))}</div></div>`;
    }
    // Renders each item in the dropdown
    renderDropdownItem(country) {
        return x `<div class="dropdown-item" tabindex="0" @click="${() => this.selectCountry(country)}" @keyup="${(e) => this.handleKeyUp(e, country)}"><span class="flag">${country.flag}</span> <span>${country.code} (${country.name})</span></div>`;
    }
    // Main component render
    render() {
        return x `<div class="form-phone-field"><div class="label-container"><label for="${this.id}-form-phone-field-label">[Label]</label></div>${this.renderError()}<div class="inputs-container"><div class="country-code"><div class="label-container"><label for="${this.id}-dropdown-input">Country code</label></div><div class="input-container"><input id="${this.id}-dropdown-input" class="dropdown-input" type="text" name="countryCode" placeholder="Select country code" aria-labelledby="${this.id}-dropdown-label" .value="${this.filterText}" @input="${this.handleInput}" @blur="${this.handleBlur}"> <svg @click="${this.toggleDropdown}" @keyup="${() => { }}" class="chevron ${this.isOpen ? 'up' : 'down'}" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><mask id="mask0_385_1542" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"><rect width="24" height="24" fill="#D9D9D9"/></mask><g mask="url(#mask0_385_1542)"><path d="M12.3504 14.9484C12.2171 14.9484 12.0921 14.9276 11.9754 14.8859C11.8587 14.8443 11.7504 14.7734 11.6504 14.6734L7.05039 10.0734C6.86706 9.8901 6.77539 9.65677 6.77539 9.37344C6.77539 9.0901 6.86706 8.85677 7.05039 8.67344C7.23372 8.4901 7.46706 8.39844 7.75039 8.39844C8.03372 8.39844 8.26706 8.4901 8.45039 8.67344L12.3504 12.5734L16.2504 8.67344C16.4337 8.4901 16.6671 8.39844 16.9504 8.39844C17.2337 8.39844 17.4671 8.4901 17.6504 8.67344C17.8337 8.85677 17.9254 9.0901 17.9254 9.37344C17.9254 9.65677 17.8337 9.8901 17.6504 10.0734L13.0504 14.6734C12.9504 14.7734 12.8421 14.8443 12.7254 14.8859C12.6087 14.9276 12.4837 14.9484 12.3504 14.9484Z" fill="#aa0061"/></g></svg></div></div><div class="phone-number"><div class="label-container"><label for="${this.id}-phone-input">Phone number</label></div><input id="${this.id}-phone-input" class="phone-input" type="tel" placeholder="Enter phone number" .value="${this.phoneNumber}" @input="${this.handlePhoneNumberChange}"></div></div><input class="${this.class}" id="${this.id}" type="hidden" name="${this.name}" .value="${this.selectedCode + this.phoneNumber}" data-f-type="hidden"><div class="phone-number-container">${this.renderDropdown()}</div></div>`;
    }
}
FormPhoneField.styles = css_248z;
__decorate([
    n({ type: String })
], FormPhoneField.prototype, "id", void 0);
__decorate([
    n({ type: String })
], FormPhoneField.prototype, "name", void 0);
__decorate([
    n({ type: String })
], FormPhoneField.prototype, "class", void 0);
__decorate([
    n({ type: String })
], FormPhoneField.prototype, "dataFDataInput", void 0);
__decorate([
    n({ type: String })
], FormPhoneField.prototype, "selectedCode", void 0);
__decorate([
    n({ type: String })
], FormPhoneField.prototype, "phoneNumber", void 0);
__decorate([
    n({ type: Array })
], FormPhoneField.prototype, "countries", void 0);
__decorate([
    n({ type: String })
], FormPhoneField.prototype, "filterText", void 0);
__decorate([
    n({ type: Boolean })
], FormPhoneField.prototype, "isOpen", void 0);
__decorate([
    n({ type: String })
], FormPhoneField.prototype, "errorMessage", void 0);
__decorate([
    n({ type: Boolean })
], FormPhoneField.prototype, "required", void 0);
customElements.define('form-phone-field', FormPhoneField);

export { FormPhoneField };
